module.exports = __webpack_public_path__ + "img/360JA.3a2cea75.png";